import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantEditEmploymentPage = {
  alert: {
    error: 'applicant-edit-employment.alert.error',
  },
  footer: {
    root: 'applicant-edit-employment.footer.root',
  },
  form: {
    cancelButton: 'applicant-edit-employment.form.cancel-button',
    employerNameInput: 'applicant-edit-employment.form.employer-name-input',
    employerNameInputError:
      'applicant-edit-employment.form.employer-name-input-error',
    employmentDurationSelect:
      'applicant-edit-employment.form.employment-duration-select',
    employmentDurationSelectError:
      'applicant-edit-employment.form.employment-duration-select-error',
    employmentStatusSelect:
      'applicant-edit-employment.form.employment-status-select',
    employmentStatusSelectError:
      'applicant-edit-employment.form.employment-status-select-error',
    employmentTypeSelect:
      'applicant-edit-employment.form.employment-type-select',
    employmentTypeSelectError:
      'applicant-edit-employment.form.employment-type-select-error',
    grossAnnualIncomeInput:
      'applicant-edit-employment.form.gross-annual-income-input',
    grossAnnualIncomeInputError:
      'applicant-edit-employment.form.gross-annual-income-input-error',
    h1: 'applicant-edit-employment.form.h1',
    h2: 'applicant-edit-employment.form.h2',
    jobTitleInput: 'applicant-edit-employment.form.job-title-input',
    jobTitleInputError: 'applicant-edit-employment.form.job-title-input-error',
    previousEmployerNameInput:
      'applicant-edit-employment.form.previous-employer-name-input',
    previousEmployerNameInputError:
      'applicant-edit-employment.form.previous-employer-name-input-error',
    previousEmploymentGrossAnnualIncomeInput:
      'applicant-edit-employment.form.previous-employment-gross-annual-income-input',
    previousEmploymentGrossAnnualIncomeInputError:
      'applicant-edit-employment.form.previous-employment-gross-annual-income-input-error',
    previousEmploymentH3:
      'applicant-edit-employment.form.previous-employment-h3',
    previousEmploymentJobTitleInput:
      'applicant-edit-employment.form.previous-employment-job-title-input',
    previousEmploymentJobTitleInputError:
      'applicant-edit-employment.form.previous-employment-job-title-input-error',
    previousEmploymentRoot:
      'applicant-edit-employment.form.previous-employment-root',
    previousEmploymentTypeSelect:
      'applicant-edit-employment.form.previous-employment-type-select',
    previousEmploymentTypeSelectError:
      'applicant-edit-employment.form.previous-employment-type-select-error',
    root: 'applicant-edit-employment.form.root',
    submitButton: 'applicant-edit-employment.form.submit-button',
    unemploymentGrossAnnualIncomeInput:
      'applicant-edit-employment.form.unemployment-gross-annual-income-input',
    unemploymentGrossAnnualIncomeInputError:
      'applicant-edit-employment.form.unemployment-gross-annual-income-input-error',
    unemploymentTypeSelect:
      'applicant-edit-employment.form.unemployment-type-select',
    unemploymentTypeSelectError:
      'applicant-edit-employment.form.unemployment-type-select-error',
  },
  header: {
    drawerButton: 'applicant-edit-employment.header.drawer-button',
    previousStepButton: 'applicant-edit-employment.header.previous-step-button',
    root: 'applicant-edit-employment.header.root',
  },
  progress: {
    root: 'applicant-edit-employment.progress.root',
  },
} as const satisfies PageLocatorMap;
